import { RootState } from "@/fe-core/meta/types/root";
import { themeState } from "@/fe-core/meta/types/theme";

export const themeSelector = ({ theme }: RootState): themeState => theme;
